/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {AirtableConfiguration as ɵa,TableOptions as ɵb} from './lib/interfaces';
export {AirtableConfigToken as ɵc} from './lib/tokens';